import { useEffect } from 'react';
import { AppBar, Box, Hidden, IconButton, Toolbar, SvgIcon, Link, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { Menu as MenuIcon } from 'react-feather';
import Logo from 'components/Logo';
import CompanyLogo from 'components/CompanyLogo';
import Account from './Account';
import Items from './Items';
import { useSnackbar } from 'notistack';

const styles = {
  toolbar: {
    minHeight: 64
  },
  appBar: {
    backgroundColor: '#2e2e2e'
  },
  separator: {
    background: '#111111',
    borderRight: '1px solid #3B3B3B',
    float: 'left',
    height: '42px',
    width: '1px',
    marginRight: '10px',
    marginLeft: '10px'
  }
};

function TopBar({ className, onMobileNavOpen, ...rest }: any) {
  const user = useSelector((state: any) => state.account.user);
  const { enqueueSnackbar } = useSnackbar();

  let homepage_url = '/';
  if (user.role === 'not_role') {
    homepage_url = '/unauthorized';
  }

  const queryParams = Object.fromEntries(
    new Map(
      window.location.search
        .replace('?', '')
        .split('&')
        ?.map(e => {
          return e.split('=');
        }) as any
    )
  );

  useEffect(() => {
    if (queryParams['unauthorized']) {
      enqueueSnackbar('Usted no tiene permiso para acceder a este recurso', { variant: 'error' });
    }
  }, [queryParams, enqueueSnackbar]);

  return (
    <AppBar sx={styles.appBar} {...rest}>
      <Toolbar sx={styles.toolbar}>
        {/* MENU */}
        <Hidden mdUp>
          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Hidden>

        {/* LOGO */}
        <Hidden mdDown>
          <Link href={homepage_url}>
            <Logo />
          </Link>
        </Hidden>
        <div
          style={{
            background: '#111111',
            borderRight: '1px solid #3B3B3B',
            float: 'left',
            height: '42px',
            width: '1px',
            marginRight: '10px',
            marginLeft: '10px'
          }}
        />
        <Grid ml={2} container>
          <Hidden mdDown>
            <Grid item>
              <Items />
            </Grid>
            <Grid item md={5}>
              <Link href={homepage_url}>
                <CompanyLogo />
              </Link>
            </Grid>
          </Hidden>
        </Grid>
        <Box ml={2}>
          <Account />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default TopBar;
